import React, {StrictMode, useEffect} from "react";
import {Equipment} from "@App/types";
import {useVehicleEquipments} from "@App/hooks/api/useVehicleEquipments";
import {EquipmentListSkeleton} from "@App/Components/Vehicletree/EquipmentList/EquipmentListSkeleton";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {actionCreators, State} from '@App/state'
import {Checkbox} from "@App/Components/common/Checkbox";
import {useTranslation} from "react-i18next";

type EquipmentListProps = {
    onNoEquipmentFound: () => void
}

export const EquipmentList = React.memo<EquipmentListProps>((props: EquipmentListProps) => {

    const {t} = useTranslation()
    const {loading, equipments: allEquipments, error} = useVehicleEquipments();
    const equipments = useSelector((state: State) => state.orders.equipments)

    useEffect(() => {
        if (!loading && !error && allEquipments.length === 0) {
            props.onNoEquipmentFound()
        }
    }, [loading, error, allEquipments])

    const dispatch = useDispatch();
    const {addEquipment, removeEquipment} = bindActionCreators(actionCreators, dispatch)

    const toggleEquipment = (equipment: Equipment): void => {
        let exists = equipments.some(p => p.id === equipment.id)

        if (exists) {
            removeEquipment(equipment)
            return
        }
        addEquipment(equipment)
    }


    if (loading) {
        return (
            <EquipmentListSkeleton/>
        )
    }

    if (error) {
        return <div>{t('error')}</div>
    }

    return (
        <StrictMode>
            <div className="mt-5">
                {allEquipments && allEquipments.map((equipment) => (
                    <Checkbox
                        key={equipment.name}
                        id={equipment.name}
                        title={equipment.name}
                        status={equipments.includes(equipment)}
                        onChange={() => toggleEquipment(equipment)}/>
                ))}
            </div>
        </StrictMode>
    );
})
